import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import FlexBox from 'flexbox-react';
import StyledSelect from 'components/StyledSelect';
import styles from 'styles/form';
import { WORKORDER_TYPE } from 'config/constants';
import { error, woSourceOptions } from '../../../../../../utils';
import BreakLine from 'components/BreakLine';

import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';


const largeInput = cx(styles.inputs, styles.largeInput);
const titleStyle = cx(styles.bottomTitle, styles.childTitle);

const expand = keyframes`
0% {
    transform: translateY(-100%);
    opacity: 0;
  }

100% {
    transform: translateY(0);
    opacity: 1;
  }
`;
/**
 * If phase has been created it will have a phase.id. When using the DropdownDiv component
 * you need to pass the phase.id if it exists, or an empty string using this format for the
 * DropdownDiv prop: phaseID={phase.id ? phase.id : ''}
 * Emotion will make the props passed to that component available to be used in styling it.
 * Here we are checking if the string is empty, indicating a new phase, therefore using the
 * animation. Otherwise no animation is set and the fields are visible from the start, which
 * is the desired behavior for existing phases being edited.
 */
const DropdownDiv = styled.div(props => ({
  animation: props.phaseID === '' ? `${expand} 400ms ease-out` : '',
}));

const ContainerDiv = styled.div`
overflow: hidden;
`;

const WorkorderInfoForm = (props) => {
  const { errors, phase, onChange } = props;
  return (<ContainerDiv>
    <DropdownDiv phaseID={phase.id ? phase.id : ''}>
      <FlexBox flexWrap="wrap" className={styles.divider}>
        <h5 className={titleStyle}>Workorder Source / Type</h5>
        <BreakLine />
        <StyledSelect
          className={largeInput}
          label="Workorder Source"
          onChange={selection => onChange('wo_source', selection)}
          options={woSourceOptions(phase)}
          value={phase.wo_source}
          placeholder={'Select Workorder Source'}
          error={error('type', errors)}
          required
        />
        <StyledSelect
          className={largeInput}
          label="Workorder Type"
          onChange={selection => onChange('wo_type', selection)}
          options={WORKORDER_TYPE.map(wt => ({ value: wt, label: wt }))}
          value={phase.wo_type}
          placeholder={'Select Workorder Type'}
          error={error('type', errors)}
          required
        />
      </FlexBox>
    </DropdownDiv>
  </ContainerDiv>);
};

WorkorderInfoForm.propTypes = {
  onChange: PropTypes.func,
  errors: PropTypes.object,
  phase: PropTypes.object,
  isEdit: PropTypes.bool,
};

export default WorkorderInfoForm;




// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseEdit/components/workorderInfoForm.jsx